import { Request } from 'api';
import { AxiosResponse } from 'axios';

export interface ScrapedEvent {
    event: string;
    mark: string;
    date: string;
    meet_date: string | null;
    meet_name: string;
    location: string;
    result_value: number;
    result_unit: string;
    is_duplicate: boolean;
    existing_source: string | null;
}

export interface AthleticNetScrapedDataResponse {
    events: ScrapedEvent[];
    athlete_name: string;
    athlete_uuid: string;
    url: string;
    total_count: number;
    new_count: number;
    duplicate_count: number;
}

type ReturnType = Promise<AxiosResponse<AthleticNetScrapedDataResponse>>;

const getAthleticNetScrapedData = (jobId: string): ReturnType => {
    return Request.get(`/workouts/track-events/athletic-net-scraped-data/${jobId}`);
};

export default getAthleticNetScrapedData;
